/* unplugin-vue-components disabled */import { render } from "./privaryContent.vue?vue&type=template&id=27c22cfa&scoped=true"
import script from "./privaryContent.vue?vue&type=script&lang=js"
export * from "./privaryContent.vue?vue&type=script&lang=js"

import "./privaryContent.vue?vue&type=style&index=0&id=27c22cfa&lang=less&scoped=true"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c22cfa"]])

export default __exports__